/* eslint-disable import/prefer-default-export */
import { parse, isWithinInterval } from 'date-fns';
/**
 * Gets the productCode using the modality name
 *
 * @param {string} modality - Modality name
 * @param {array} products - List of products from get product and modalities
 * @param {string} serviceDate - the date used to determine active product
 * @returns {string} - productCode if found, otherwise returns null
 */
export const getProductCodeFromModality = (modality, products, serviceDate = null) => {
  let product = products.filter((prod) => {
    // DE2E-6968 fix: Change below to use optional chaining, otherwise if the product doesn't have a modalities list, .some() will error
    return prod.modalities?.some((prodMod) => {
      return prodMod.modalityName === modality;
    });
  });
  if(serviceDate){
    const today = new Date(new Date().toDateString());
    const tenYearslaterToday = new Date(today.getFullYear() + 10, today.getMonth(), today.getDate());
    const date = parse(serviceDate, 'yyyy-MM-dd', new Date());
    product = product.find((prod) => {
      const startDate = parse(prod.startDate, 'yyyy-MM-dd', new Date());
      const endDate = prod.endDate ? parse(prod.endDate, 'yyyy-MM-dd', new Date()) : tenYearslaterToday;
      return isWithinInterval(date, { start: startDate, end: endDate });
    });
  }

  if (product) {
    return product.productCode;
  }

  return null;
};